import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { switchMap, map, take, from, of, catchError } from 'rxjs';
import { JwtService } from '@okcargo-apps/services';
import { AccountService } from '../../account/application/account.service';
import { ECapabilities } from '../../account/domain/account.model';

export const loginGuard: CanActivateFn = (route, state) => {
  const accountService = inject(AccountService);
  const jwtService = inject(JwtService);
  const router = inject(Router);

  return jwtService.userDataReceived$.pipe(
    take(1),
    switchMap((userDataReceived) => {
      if (userDataReceived) {
        return accountService.hasCapability$(ECapabilities.AUTHENTICATED).pipe(
          map((hasCap) => {
            if (hasCap) {
              router.navigate(['/crm/companies']);
              return false;
            }
            return true;
          }),
        );
      } else {
        const accessToken = jwtService.accessToken;
        const refreshToken = jwtService.refreshToken;
        if (accessToken && refreshToken) {
          return from(accountService.checkUserAuthentication()).pipe(
            switchMap(() => accountService.hasCapability$(ECapabilities.AUTHENTICATED)),
            map((hasCap) => {
              if (hasCap) {
                router.navigate(['/crm/companies']);
                return false;
              }
              return true;
            }),
            catchError(() => of(true)),
          );
        } else {
          return of(true);
        }
      }
    }),
  );
};
